import useVuelidate from '@vuelidate/core';

import { required, email, phone } from '@/utils/validators';
import taiwanDistricts from '@/utils/taiwanDistricts';
import { PRICE_PER_MEMBER } from '@/utils/constants';

export default {
  name: 'PlanSelector',
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      memberCount: 11,
      unitPrice: PRICE_PER_MEMBER,
      enableContactModal: false,
      currentStep: 1,
      contactForm: {
        name: '',
        team_name: '',
        email: '',
        scale: 1,
        phone: '',
        city: '台中市',
        contact_time: 0,
        requests: '',
      },
      sourceList: [
        'Google',
        'Facebook',
        'DM宣傳',
        '曾使用好彙訂',
        '其他',
      ],
      scaleList: [
        '1-10人',
        '11-50人',
        '51-100人',
        '101人以上',
      ],
      questionList: [
        '操作與技術諮詢',
        '方案與費用諮詢',
        '洽詢客製方案',
        '洽詢系統串接',
      ],
    };
  },
  computed: {
    standardPlanPrice() {
      return this.memberCount * this.unitPrice;
    },
    cityList() {
      return taiwanDistricts.map(({ name }) => name);
    },
  },
  methods: {
    onUpgrade() {
      this.$emit('upgrade');
    },
    async onSubmit() {
      const valid = await this.v$.$validate();
      if (!valid) {
        return;
      }
      this.$emit('contact', this.contactForm);
    },
    reset() {
      this.enableContactModal = false;
      Object.assign(this.$data.contactForm, this.$options.data().contactForm);
      this.v$.reset();
    },
  },
  validations() {
    return {
      contactForm: {
        name: {
          required: required('姓名'),
        },
        team_name: {
          required: required('公司名稱'),
        },
        email: {
          required: required('電子信箱'),
          email,
        },
        scale: {
          required: required('公司規模'),
        },
        phone: {
          required: required('聯絡電話'),
          phone,
        },
      },
    };
  },
};
